module.exports = __webpack_public_path__ + "img/shrubs_grey_al.29380d14.svg";